export enum IframeState {
    PendingInitialization = "PendingInitialization",
    Initialized = "Initialized",
    Error = "Error",
}
